import { v4 as uuidv4 } from 'uuid'
import { meta } from '@/db/database'
import { storage } from '@/lib/storage'

const UID_KEY = 'device_uid'
const LINK_KEY = 'device_link'

export interface DeviceLink {
  device_id: string
  linked_at: string
  /** The branch the Connect code was made for (POS.md §18.2); absent on links made before branches were bound. */
  branch_id?: string | null
}

/**
 * This browser's id (POS.md O2). Browsers have no permanent device id, so one is made the first time and kept in
 * localStorage and the device database, with persistent storage requested so the browser does not evict it. Clearing
 * site data loses it: the browser then links again as a new device.
 */
export const getDeviceUid = (): string => {
  let uid = storage.read<string | null>(UID_KEY, null)
  if (!uid) {
    uid = uuidv4()
    storage.write(UID_KEY, uid)
    meta.set(UID_KEY, uid).catch(() => undefined)
    navigator.storage?.persist?.().catch(() => undefined)
  }
  return uid
}

export const readDeviceLink = () => storage.read<DeviceLink | null>(LINK_KEY, null)
export const writeDeviceLink = (link: DeviceLink | null) => storage.write(LINK_KEY, link)
